import React, { useEffect, useState } from "react";
import { Link as DomLink } from "react-router-dom";
import moment from "moment";
import qs from "qs";
import api from "../../../utils/api";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";

export default function Articles(props) {
  const [articles, setArticles] = useState();
  const [page, setPage] = useState();
  const [totalPages, setTotalPages] = useState();
  const initialQuery = qs.stringify({
    pagination: {
      page: page,
      pageSize: 20,
    },
  });

  const handlePageChange = (event, value) => {
    const pageQuery = qs.stringify({
      pagination: {
        page: value,
        pageSize: 20,
      },
    });
    api.fetchStrapi(`/technical-articles?${pageQuery}`).then((response) => {
      setArticles(response.data.data);
      setPage(value);
      window.scrollTo(0, 0);
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    api.fetchStrapi(`/technical-articles?${initialQuery}`).then((response) => {
      setArticles(response.data.data);
      setPage(response.data.meta.pagination.page);
      setTotalPages(response.data.meta.pagination.pageCount);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container className="careers-text">
      <Stack spacing={1}>
        <Typography variant="articleTitle" align="center">
          Technical Articles
        </Typography>
        <Divider sx={{ marginTop: "5rem", marginBottom: "2rem" }} />
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              sm: "repeat(1, 1fr)",
              md: "repeat(2, 1fr)",
              lg: "repeat(3, 1fr)",
              xl: "repeat(4, 1fr)",
            },
          }}
        >
          {articles &&
            articles.map((article) => (
              <Card
                sx={{
                  margin: "1rem",
                  backgroundColor: "#f0f0f0",
                  display: "grid",
                }}
                key={article.id}
                variant="outlined"
              >
                <CardContent>
                  <Stack spacing={1}>
                    <Typography variant="h3">
                      {article.attributes.title}
                    </Typography>
                    <Divider />
                    <Typography variant="articleSubTitle" align="center">
                      {`${article.attributes.author} | ${moment(
                        article.attributes.date
                      ).format("MMM Do YYYY")}`}
                    </Typography>
                    <Typography variant="article">
                      {article.attributes.subtitle}
                    </Typography>
                    <DomLink
                      to={{
                        pathname: `/technicalarticles/${article.id}`,
                      }}
                    >
                      <Button variant="outlined" sx={{ width: "100%" }}>
                        Read More
                      </Button>
                    </DomLink>
                  </Stack>
                </CardContent>
              </Card>
            ))}
        </Box>
        <Pagination
          count={totalPages}
          color="primary"
          variant="outlined"
          shape="rounded"
          onChange={handlePageChange}
        />
      </Stack>
    </Container>
  );
}
